import state from 'store';
import { h } from '@stencil/core';
import { i18n } from 'i18n';
import contactModal from 'store/contactModal';
import { copyToClipboard } from 'utils/utils';
import { triggerTrackEvent } from 'utils/events';
import initParams from 'store/initParams';

const cardContentStyle = {
  'display': 'flex',
  'gap': '8px',
  'flex-direction': 'column',
};

function track(eventType: string) {
  triggerTrackEvent({ event_type: 'click', event_name: 'cdc_modal', data: { contactType: eventType } });
}

function copyAndTrack(content: string) {
  track('number-copy');
  copyToClipboard(content);
}
function createPhoneCard(title: string, number: string, tabIndex: string) {
  return (
    <div class="eva-3-card -eva-3-shadow-line -eva-3-p-md -eva-3-m-sm" tabindex={tabIndex}>
      <div style={cardContentStyle}>
        <div>
          <h5 class="eva-3-h5 -eva-3-mb-sm">{title}</h5>
          <div class="eva-3-body-1 info-card-item" style={{ 'display': 'flex', 'gap': '8px', 'flex-direction': 'row' }}>
            <span class="eva-3-link" onClick={() => copyAndTrack(number)}>
              {number}
            </span>
            <i
              class="eva-3-icon-copy btn-icon"
              style={{
                color: 'var(--brand-primary-3)',
                cursor: 'pointer',
              }}
              onClick={() => copyAndTrack(number)}
            />
          </div>
        </div>
        <div>
          <a
            class={{
              'eva-3-btn-ghost -md': true,
              'hide': !initParams.isMobile,
            }}
            href={`tel:${number}`}
            onClick={() => track('call')}
          >
            <em class="btn-text">{i18n.t.boards.contactBoard.call}</em>
            <i class={`eva-3-icon-phone btn-icon`} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default function CDCModal({ show }: { show: boolean }) {
  const onClose = () => {
    state.showFullScreenModal = null;
  };

  const phoneInfo = contactModal.phoneInfo;
  const localCard = phoneInfo && createPhoneCard(i18n.t.boards.contactBoard.localNumber, phoneInfo.localNumber, '1');
  const exteriorCard = phoneInfo && createPhoneCard(i18n.t.boards.contactBoard.exteriorNumber, phoneInfo.exteriorNumber, '2');

  return show ? (
    <div id="view-more-modal" role="presentation" class={'eva-3-modal -smooth-scroll fullscreen-modal -show-modal'}>
      <div class="modal-header" role="presentation">
        <div class="modal-title-container">
          <h4 class="eva-3-h4 modal-title">{i18n.t.boards.contactBoard.phonesModalTitle}</h4>
        </div>
        <i
          class="eva-3-icon-cross modal-close -eva-3-mr-md"
          role="button"
          tabindex="0"
          aria-label={i18n.t.chat.message.feedback.close}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <div class="modal-content" role="presentation">
        <span class="eva-3-body-1">{i18n.t.boards.contactBoard.reservationNumberReminder}</span>
        {localCard}
        {exteriorCard}
      </div>
    </div>
  ) : null;
}
